// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userData_header {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 16px 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
    gap: 12px;
}

.userData_informations,
.userData_features {
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 40px;
    align-items: flex-start;
    flex-wrap: wrap;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
}

.userData_kyc {
    min-width: 0;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    overflow: hidden;
}

.userData_kyc_box {
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: 16px;
}

.userData_image {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
}

.userById_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.userData_profil {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 12px;
}

.user_profile_pic {
    width: 56px;
    height: 56px;
    border-radius: var(--radius-md);
    object-fit: cover;
}

.user_profil_name {
    display: flex;
    gap: 5px;
    margin: 0px;
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.user_profil_email {
    margin: 0px;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-secondary);
}

.partner_timeframe_box,
.user_header_action_button_box {
    display: flex;
    flex-direction: row;
    gap: 6px;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 10px;
    border-top: 1px solid var(--border);
}

.userData_action_button,
.userData_update_features {
    background-color: var(--primary);
    padding: 6px 12px;
    border-radius: var(--radius-sm);
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    transition: all var(--transition-fast);
    white-space: nowrap;
}

.userData_action_button:hover,
.userData_update_features:hover {
    background-color: var(--primary-hover);
}

.close_alpaca_account_button,
.userData_update_cancel_button {
    background-color: var(--danger);
    padding: 6px 12px;
    border-radius: var(--radius-sm);
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    transition: all var(--transition-fast);
    white-space: nowrap;
}

.close_alpaca_account_button:hover,
.userData_update_cancel_button:hover {
    background-color: #DC2626;
}

.userData_registerinfo {
    display: flex;
    flex-direction: column;
}

.user_document_upload {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
}

.user_documents_types_container {
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.user_document_type {
    margin: 0 0 16px 0;
    font-size: 17px;
    font-weight: 700;
    color: var(--text-primary);
}

.partner_box_subtitle,
.user_document_sumsub_type {
    font-size: 17px;
    font-weight: 700;
    color: var(--text-primary);
}

.user_file_upload {
    display: none;
}

.userData_documents_container {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
}

.userData_documents {
    max-width: 200px;
}

.userData_doc_item {
    max-width: 200px;
    border-radius: var(--radius-lg);
}

.user_doc_title {
    margin: 0 0 16px 0;
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.userData_p {
    margin: 5px 0;
}

.userData_chiffres {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
    align-items: stretch;
    gap: 20px;
}

.userData_multi_box {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
    align-items: stretch;
    gap: 20px;
}

.userData_chiffres_user {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    min-width: 0;
}

.userData_multi_box_container {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    min-width: 0;
}

.userData_leverage {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    min-width: 0;
}

.userData_case {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    gap: 15px;
    border: 1px solid var(--border);
}

.userData_fraud {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    min-width: 0;
    border: 1px solid var(--border);
}

.userData_fraud_box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 20px;
}

.userData_partner_update_box,
.userData_free_transactions_update_box {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.userData_partner_input,
.userData_free_transactions_input {
    line-height: 1.6rem;
    width: 100px;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 0px 10px;
}

.userData_action_button:disabled {
    background-color: var(--primary-50);
    cursor: not-allowed;
}

.userData_add_referral_button {
    background-color: var(--primary);
    padding: 10px 18px;
    border-radius: var(--radius-sm);
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    transition: all var(--transition-fast);
}

.userData_add_referral_button:hover {
    background-color: var(--primary-hover);
}

.userData_free_transactions_title {
    margin: 0;
    font-size: 13px;
    color: var(--text-muted);
}

.userData_chiffres_wallet {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    min-width: 0;
}

.userData_report_container {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    min-width: 0;
}

.userData_wallet_box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.user_row_space_between_box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.user_provider_access_box {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
}

.userData_report_box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.userData_item_title {
    margin: 0;
    font-size: 13px;
    display: block;
    color: var(--text-muted);
}

.userData_item_desc {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
}

.userData_box {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.userData_item_edition {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
}

.userData_edition_input {
    width: 300px;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 6px 12px;
    line-height: 1.5rem;
    font-size: 14px;
}

.history_export_box {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    gap: 60px;
}

.history_export_box_item {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
}

.user_action_button {
    background-color: var(--primary);
    padding: 8px 20px;
    border-radius: var(--radius-sm);
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    transition: all var(--transition-fast);
}

.user_action_button:hover {
    background-color: var(--primary-hover);
}

.user_action_button:disabled {
    background-color: var(--primary-50);
    cursor: not-allowed;
}

.user_edit_button_div {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.label_title {
    margin: 0;
    font-size: 13px;
    display: block;
    color: var(--text-muted);
}

.label_value {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
}

.multi_account_device {
    color: var(--danger);
}

.mono_account_device {
    color: var(--success);
}

.update_risk_level_box {
    display: flex;
    align-items: center;
    gap: 10px;
}

.close_alpaca_account_modal_box {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.close_alpaca_account_modal_reason_select {
    align-self: center;
}

.close_alpaca_account_modal_button_div {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.close_alpaca_account_validate_button {
    padding: 8px 20px;
    border-radius: var(--radius-sm);
    background-color: var(--danger);
    border: none;
    color: white;
    font-weight: 600;
    transition: all var(--transition-fast);
}

.close_alpaca_account_validate_button:hover {
    background-color: #DC2626;
}

.close_alpaca_account_close_modal_button {
    padding: 8px 20px;
    border-radius: var(--radius-sm);
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    color: var(--text-secondary);
    font-weight: 500;
    transition: all var(--transition-fast);
}

.close_alpaca_account_close_modal_button:hover {
    background-color: var(--bg);
}

.close_alpaca_account_validate_button:disabled {
    background-color: var(--danger);
    opacity: 0.5;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/userById.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,kBAAkB;IAClB,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;IAC5B,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;;IAEI,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;;IAEI,+BAA+B;IAC/B,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;IAC/B,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,SAAS;IACT,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,+BAA+B;IAC/B,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;IAC5B,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".userData_header {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 16px 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n    gap: 12px;\n}\n\n.userData_informations,\n.userData_features {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    gap: 40px;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n}\n\n.userData_kyc {\n    min-width: 0;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    overflow: hidden;\n}\n\n.userData_kyc_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    gap: 16px;\n}\n\n.userData_image {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n}\n\n.userById_container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.userData_profil {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: center;\n    gap: 12px;\n}\n\n.user_profile_pic {\n    width: 56px;\n    height: 56px;\n    border-radius: var(--radius-md);\n    object-fit: cover;\n}\n\n.user_profil_name {\n    display: flex;\n    gap: 5px;\n    margin: 0px;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.user_profil_email {\n    margin: 0px;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-secondary);\n}\n\n.partner_timeframe_box,\n.user_header_action_button_box {\n    display: flex;\n    flex-direction: row;\n    gap: 6px;\n    align-items: center;\n    flex-wrap: wrap;\n    padding-top: 10px;\n    border-top: 1px solid var(--border);\n}\n\n.userData_action_button,\n.userData_update_features {\n    background-color: var(--primary);\n    padding: 6px 12px;\n    border-radius: var(--radius-sm);\n    border: none;\n    outline: none;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    color: #fff;\n    transition: all var(--transition-fast);\n    white-space: nowrap;\n}\n\n.userData_action_button:hover,\n.userData_update_features:hover {\n    background-color: var(--primary-hover);\n}\n\n.close_alpaca_account_button,\n.userData_update_cancel_button {\n    background-color: var(--danger);\n    padding: 6px 12px;\n    border-radius: var(--radius-sm);\n    border: none;\n    outline: none;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    color: #fff;\n    transition: all var(--transition-fast);\n    white-space: nowrap;\n}\n\n.close_alpaca_account_button:hover,\n.userData_update_cancel_button:hover {\n    background-color: #DC2626;\n}\n\n.userData_registerinfo {\n    display: flex;\n    flex-direction: column;\n}\n\n.user_document_upload {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: center;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n\n.user_documents_types_container {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n\n.user_document_type {\n    margin: 0 0 16px 0;\n    font-size: 17px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.partner_box_subtitle,\n.user_document_sumsub_type {\n    font-size: 17px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.user_file_upload {\n    display: none;\n}\n\n.userData_documents_container {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: center;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n\n.userData_documents {\n    max-width: 200px;\n}\n\n.userData_doc_item {\n    max-width: 200px;\n    border-radius: var(--radius-lg);\n}\n\n.user_doc_title {\n    margin: 0 0 16px 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.userData_p {\n    margin: 5px 0;\n}\n\n.userData_chiffres {\n    display: grid;\n    grid-template-columns: 1fr 1.5fr;\n    align-items: stretch;\n    gap: 20px;\n}\n\n.userData_multi_box {\n    display: grid;\n    grid-template-columns: 1fr 1.5fr;\n    align-items: stretch;\n    gap: 20px;\n}\n\n.userData_chiffres_user {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    min-width: 0;\n}\n\n.userData_multi_box_container {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    min-width: 0;\n}\n\n.userData_leverage {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    min-width: 0;\n}\n\n.userData_case {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    gap: 15px;\n    border: 1px solid var(--border);\n}\n\n.userData_fraud {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    min-width: 0;\n    border: 1px solid var(--border);\n}\n\n.userData_fraud_box {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 20px;\n}\n\n.userData_partner_update_box,\n.userData_free_transactions_update_box {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n}\n\n.userData_partner_input,\n.userData_free_transactions_input {\n    line-height: 1.6rem;\n    width: 100px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 0px 10px;\n}\n\n.userData_action_button:disabled {\n    background-color: var(--primary-50);\n    cursor: not-allowed;\n}\n\n.userData_add_referral_button {\n    background-color: var(--primary);\n    padding: 10px 18px;\n    border-radius: var(--radius-sm);\n    border: none;\n    outline: none;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 600;\n    color: #fff;\n    transition: all var(--transition-fast);\n}\n\n.userData_add_referral_button:hover {\n    background-color: var(--primary-hover);\n}\n\n.userData_free_transactions_title {\n    margin: 0;\n    font-size: 13px;\n    color: var(--text-muted);\n}\n\n.userData_chiffres_wallet {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    min-width: 0;\n}\n\n.userData_report_container {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    min-width: 0;\n}\n\n.userData_wallet_box {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n}\n\n.user_row_space_between_box {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n}\n\n.user_provider_access_box {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 20px;\n}\n\n.userData_report_box {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n}\n\n.userData_item_title {\n    margin: 0;\n    font-size: 13px;\n    display: block;\n    color: var(--text-muted);\n}\n\n.userData_item_desc {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.userData_box {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.userData_item_edition {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.userData_edition_input {\n    width: 300px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 6px 12px;\n    line-height: 1.5rem;\n    font-size: 14px;\n}\n\n.history_export_box {\n    display: flex;\n    flex-direction: row;\n    justify-content: left;\n    align-items: center;\n    gap: 60px;\n}\n\n.history_export_box_item {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: center;\n}\n\n.user_action_button {\n    background-color: var(--primary);\n    padding: 8px 20px;\n    border-radius: var(--radius-sm);\n    border: none;\n    outline: none;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    color: #fff;\n    transition: all var(--transition-fast);\n}\n\n.user_action_button:hover {\n    background-color: var(--primary-hover);\n}\n\n.user_action_button:disabled {\n    background-color: var(--primary-50);\n    cursor: not-allowed;\n}\n\n.user_edit_button_div {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n}\n\n.label_title {\n    margin: 0;\n    font-size: 13px;\n    display: block;\n    color: var(--text-muted);\n}\n\n.label_value {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.multi_account_device {\n    color: var(--danger);\n}\n\n.mono_account_device {\n    color: var(--success);\n}\n\n.update_risk_level_box {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.close_alpaca_account_modal_box {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.close_alpaca_account_modal_reason_select {\n    align-self: center;\n}\n\n.close_alpaca_account_modal_button_div {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n}\n\n.close_alpaca_account_validate_button {\n    padding: 8px 20px;\n    border-radius: var(--radius-sm);\n    background-color: var(--danger);\n    border: none;\n    color: white;\n    font-weight: 600;\n    transition: all var(--transition-fast);\n}\n\n.close_alpaca_account_validate_button:hover {\n    background-color: #DC2626;\n}\n\n.close_alpaca_account_close_modal_button {\n    padding: 8px 20px;\n    border-radius: var(--radius-sm);\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    color: var(--text-secondary);\n    font-weight: 500;\n    transition: all var(--transition-fast);\n}\n\n.close_alpaca_account_close_modal_button:hover {\n    background-color: var(--bg);\n}\n\n.close_alpaca_account_validate_button:disabled {\n    background-color: var(--danger);\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
